function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// kapigen version 0.1.12
// tslint:disable
import { google } from "../../google";
import { Kaggle } from "../../../sdk";
import { createClient } from "../../../requestClientInternal";
import { CroppedImageUploadWireFormat3 as KaggleSdkCommonCroppedImageUploadWireFormat3 } from "../../common";
import { CompetitionGroupingWireFormat3 as KaggleSdkCompetitionsCompetitionGroupingWireFormat3, CompetitionKernelRerunStateWireFormat3 as KaggleSdkCompetitionsCompetitionKernelRerunStateWireFormat3, CompetitionListTabWireFormat3 as KaggleSdkCompetitionsCompetitionListTabWireFormat3, CompetitionSortByWireFormat3 as KaggleSdkCompetitionsCompetitionSortByWireFormat3, CompetitionTypeWireFormat3 as KaggleSdkCompetitionsCompetitionTypeWireFormat3, EvaluationAlgorithmWireFormat3 as KaggleSdkCompetitionsEvaluationAlgorithmWireFormat3, HostSegmentWireFormat3 as KaggleSdkCompetitionsHostSegmentWireFormat3, SubmissionGroupWireFormat3 as KaggleSdkCompetitionsSubmissionGroupWireFormat3, SubmissionSortByWireFormat3 as KaggleSdkCompetitionsSubmissionSortByWireFormat3, SubmissionStatusWireFormat3 as KaggleSdkCompetitionsSubmissionStatusWireFormat3 } from "..";
import { NewTopicDtoWireFormat3 as KaggleSdkDiscussionsNewTopicDtoWireFormat3, TopicListDtoWireFormat3 as KaggleSdkDiscussionsTopicListDtoWireFormat3 } from "../../discussions";
import { MedalWireFormat3 as KaggleSdkUsersMedalWireFormat3, UserAchievementTierWireFormat3 as KaggleSdkUsersUserAchievementTierWireFormat3, UserAvatarWireFormat3 as KaggleSdkUsersUserAvatarWireFormat3 } from "../../users";
// namespace Kaggle.Sdk.Competitions.Legacy:
export var ColumnMapping;
(function(ColumnMapping1) {
    var Type;
    (function(Type) {
        Type["UNSPECIFIED"] = "unspecified";
        Type["SOLUTION"] = "solution";
        Type["SUBMISSION"] = "submission";
    })(Type = ColumnMapping1.Type || (ColumnMapping1.Type = {}));
    var TypeWireFormat3 = ColumnMapping1.TypeWireFormat3 = {
        fromJson: function fromJson(wireFormat) {
            switch(wireFormat){
                case "TYPE_UNSPECIFIED":
                default:
                    return Type.UNSPECIFIED;
                case "SOLUTION":
                    return Type.SOLUTION;
                case "SUBMISSION":
                    return Type.SUBMISSION;
            }
        }
    };
})(ColumnMapping || (ColumnMapping = {}));
export var RescoreSubmissionsRequest;
(function(RescoreSubmissionsRequest1) {
    var SpecificSubmissionsWireFormat3 = RescoreSubmissionsRequest1.SpecificSubmissionsWireFormat3 = {
        toJson: function toJson(message) {
            return message;
        }
    };
})(RescoreSubmissionsRequest || (RescoreSubmissionsRequest = {}));
export var AddHostUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultAddHostUserResponse = {};
export var AddHostUserResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAddHostUserResponse, wireFormat);
        return message;
    }
};
var defaultBackgroundOperation = {
    id: "",
    name: "",
    done: false,
    statusUrl: ""
};
export var BackgroundOperationWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBackgroundOperation, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.metadata) {
            message.metadata = SubmissionsRangeWireFormat3.fromJson(wireFormat.metadata);
        }
        return message;
    }
};
var defaultColumnDefinition = {
    name: "",
    parsingDataType: ""
};
export var ColumnDefinitionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultColumnDefinition, wireFormat);
        return message;
    }
};
var defaultColumnMapping = {
    warnings: [],
    columnMappings: {},
    columnDefinitions: []
};
export var ColumnMappingWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultColumnMapping, wireFormat);
        if (wireFormat) {
            message.type = ColumnMapping.TypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.columnMappings) {
            message.columnMappings = {};
            Object.entries(wireFormat.columnMappings).forEach(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                message.columnMappings[key] = ColumnMappingValueWireFormat3.fromJson(value);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.columnDefinitions) {
            message.columnDefinitions = wireFormat.columnDefinitions.map(function(i) {
                return ColumnDefinitionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultColumnMappingValue = {};
export var ColumnMappingValueWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultColumnMappingValue, wireFormat);
        return message;
    }
};
var defaultCompetitionCardDto = {
    competitionId: 0,
    totalTeams: 0,
    totalKernels: 0,
    isLimited: false,
    isPrivate: false,
    isInClass: false,
    userHasEntered: false,
    userTeamUsers: [],
    maxDailySubmissions: 0,
    awardsPoints: false,
    isKernelsSubmissionsOnly: false,
    submissionsDisabled: false,
    isOngoingCompetition: false
};
export var CompetitionCardDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionCardDto, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.deadline) {
            message.deadline = new Date(wireFormat.deadline);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rewardQuantity) != undefined) {
            message.rewardQuantity = Number(wireFormat.rewardQuantity);
        }
        if (wireFormat) {
            message.hostSegment = KaggleSdkCompetitionsHostSegmentWireFormat3.fromJson(wireFormat.hostSegment);
        }
        if (wireFormat) {
            message.medal = KaggleSdkUsersMedalWireFormat3.fromJson(wireFormat.medal);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userTeamUsers) {
            message.userTeamUsers = wireFormat.userTeamUsers.map(function(i) {
                return CompetitionLeaderboardMemberDtoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
            message.categories = Kaggle.Sdk.Tags.TagListWireFormat3.fromJson(wireFormat.categories);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.mergerDeadline) {
            message.mergerDeadline = new Date(wireFormat.mergerDeadline);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.newEntrantDeadline) {
            message.newEntrantDeadline = new Date(wireFormat.newEntrantDeadline);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.enabledDate) {
            message.enabledDate = new Date(wireFormat.enabledDate);
        }
        return message;
    }
};
var defaultCompetitionCardDtoComputedFields = {
    isOngoingCompetition: false
};
export var CompetitionCardDtoComputedFieldsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionCardDtoComputedFields, wireFormat);
        return message;
    }
};
var defaultCompetitionDto = {
    competitionId: 0,
    hasAcceptedRules: false,
    totalTeams: 0,
    isInClass: false,
    canEdit: false,
    canEditMetadata: false,
    numPrizes: 0,
    leaderboardPercentage: 0,
    hasLimitedParticipation: false,
    numScoredSubmissions: 0,
    maxDailySubmissions: 0,
    totalEntries: 0,
    countsTowardsRanking: false,
    countsTowardsTiers: false,
    allowPrivateLeaderboardDisplay: false,
    isCreatingCompetition: false,
    pages: [],
    databundleVersions: [],
    rerunDatabundleVersions: [],
    submissionsAreDisabled: false,
    hasLeaderboard: false,
    finalLeaderboardHasBeenVerified: false,
    witholdFinalLeaderboardUntilItHasBeenVerified: false,
    isPrivate: false,
    disablePrizeIndicator: false,
    hasKernels: false,
    hasSolutionFile: false,
    userRankMultiplier: 0,
    needsPhoneVerification: false,
    scoringIsMax: false,
    canSubmitModel: false,
    isCompetitionHost: false,
    hostSegments: [],
    canParticipate: false,
    isCompetitionPending: false,
    competitionHasLaunched: false,
    competitionHasEnded: false,
    mergerDeadlineHasPassed: false,
    newEntrantDeadlineHasPassed: false,
    onlyAllowKernelSubmissions: false,
    requiresSameRowCountInSubmissionAndSolution: false,
    enableLazyLeaderboard: false,
    rulesRequired: false,
    usesSynchronousReruns: false,
    disableKernelsPublishing: false,
    isOngoingCompetition: false
};
export var CompetitionDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionDto, wireFormat);
        if (wireFormat) {
            message.competitionType = KaggleSdkCompetitionsCompetitionTypeWireFormat3.fromJson(wireFormat.competitionType);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateEnabled) {
            message.dateEnabled = new Date(wireFormat.dateEnabled);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.deadline) {
            message.deadline = new Date(wireFormat.deadline);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.mergerDeadline) {
            message.mergerDeadline = new Date(wireFormat.mergerDeadline);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.newEntrantDeadline) {
            message.newEntrantDeadline = new Date(wireFormat.newEntrantDeadline);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rewardQuantity) != undefined) {
            message.rewardQuantity = Number(wireFormat.rewardQuantity);
        }
        if (wireFormat) {
            message.hostSegment = KaggleSdkCompetitionsHostSegmentWireFormat3.fromJson(wireFormat.hostSegment);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rules) {
            message.rules = CompetitionPageWireFormat3.fromJson(wireFormat.rules);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataIntro) {
            message.dataIntro = CompetitionPageWireFormat3.fromJson(wireFormat.dataIntro);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.discussion) {
            message.discussion = KaggleSdkDiscussionsTopicListDtoWireFormat3.fromJson(wireFormat.discussion);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.newTopic) {
            message.newTopic = KaggleSdkDiscussionsNewTopicDtoWireFormat3.fromJson(wireFormat.newTopic);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maxDailySubmissionsResetDate) {
            message.maxDailySubmissionsResetDate = new Date(wireFormat.maxDailySubmissionsResetDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.team) {
            message.team = CompetitionTeamDtoWireFormat3.fromJson(wireFormat.team);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.evaluationAlgorithm) {
            message.evaluationAlgorithm = KaggleSdkCompetitionsEvaluationAlgorithmWireFormat3.fromJson(wireFormat.evaluationAlgorithm);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.pages) {
            message.pages = wireFormat.pages.map(function(i) {
                return CompetitionPageWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.databundleVersions) {
            message.databundleVersions = wireFormat.databundleVersions.map(function(i) {
                return Kaggle.Sdk.Datasets.CompetitionDatabundleVersionWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rerunDatabundleVersions) {
            message.rerunDatabundleVersions = wireFormat.rerunDatabundleVersions.map(function(i) {
                return Kaggle.Sdk.Datasets.CompetitionDatabundleVersionWireFormat3.fromJson(i);
            });
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userRankMultiplier) != undefined) {
            message.userRankMultiplier = Number(wireFormat.userRankMultiplier);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.mostRecentSubmissionStatus) {
            message.mostRecentSubmissionStatus = SubmissionStatusDtoWireFormat3.fromJson(wireFormat.mostRecentSubmissionStatus);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.hostSegments) {
            message.hostSegments = wireFormat.hostSegments.map(function(i) {
                return HostSegmentItemWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
            message.categories = Kaggle.Sdk.Tags.TagListWireFormat3.fromJson(wireFormat.categories);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitionHostClaims) {
            message.competitionHostClaims = CompetitionHostClaimsWireFormat3.fromJson(wireFormat.competitionHostClaims);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.modelFileSizeBytes) {
            message.modelFileSizeBytes = parseInt(wireFormat.modelFileSizeBytes);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.privateLeaderboardReleaseDate) {
            message.privateLeaderboardReleaseDate = new Date(wireFormat.privateLeaderboardReleaseDate);
        }
        return message;
    }
};
var defaultCompetitionDtoComputedFields = {
    isOngoingCompetition: false
};
export var CompetitionDtoComputedFieldsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionDtoComputedFields, wireFormat);
        return message;
    }
};
var defaultCompetitionGroupDto = {
    totalCompetitions: 0,
    competitions: []
};
export var CompetitionGroupDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionGroupDto, wireFormat);
        if (wireFormat) {
            message.grouping = KaggleSdkCompetitionsCompetitionGroupingWireFormat3.fromJson(wireFormat.grouping);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalCompetitions) {
            message.totalCompetitions = parseInt(wireFormat.totalCompetitions);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitions) {
            message.competitions = wireFormat.competitions.map(function(i) {
                return CompetitionCardDtoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultCompetitionHostClaims = {
    readSettings: false,
    writeSettings: false,
    writeDescriptions: false,
    writeDeadline: false,
    readSubmissions: false,
    writeSubmissions: false,
    invalidateSubmissions: false,
    rescoreSubmissions: false,
    readEvaluation: false,
    writeEvaluation: false,
    writeTeamVisibility: false,
    updateCategory: false,
    launchCompetition: false,
    writeBenchmarks: false,
    isCompetitionHost: false
};
export var CompetitionHostClaimsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionHostClaims, wireFormat);
        return message;
    }
};
var defaultCompetitionLeaderboardMemberDto = {};
export var CompetitionLeaderboardMemberDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionLeaderboardMemberDto, wireFormat);
        if (wireFormat) {
            message.tier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.tier);
        }
        return message;
    }
};
var defaultCompetitionLeaderboardSubmissionDto = {
    teamId: 0,
    teamMembers: [],
    entries: 0
};
export var CompetitionLeaderboardSubmissionDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionLeaderboardSubmissionDto, wireFormat);
        if (wireFormat) {
            message.medal = KaggleSdkUsersMedalWireFormat3.fromJson(wireFormat.medal);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teamMembers) {
            message.teamMembers = wireFormat.teamMembers.map(function(i) {
                return CompetitionLeaderboardMemberDtoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastSubmission) {
            message.lastSubmission = new Date(wireFormat.lastSubmission);
        }
        return message;
    }
};
var defaultCompetitionPage = {
    content: "",
    mimeType: "",
    name: ""
};
export var CompetitionPageWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionPage, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCompetitionTeamDto = {
    id: 0,
    canCreateMerger: false,
    members: []
};
export var CompetitionTeamDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionTeamDto, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.members) {
            message.members = wireFormat.members.map(function(i) {
                return CompetitionTeamMemberDtoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultCompetitionTeamInfoDto = {
    id: 0,
    entries: 0,
    entriesSizeInBytes: 0,
    isBenchmark: false
};
export var CompetitionTeamInfoDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionTeamInfoDto, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.entriesSizeInBytes) {
            message.entriesSizeInBytes = parseInt(wireFormat.entriesSizeInBytes);
        }
        return message;
    }
};
var defaultCompetitionTeamMemberDto = {
    userId: 0,
    isTeamLeader: false
};
export var CompetitionTeamMemberDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionTeamMemberDto, wireFormat);
        if (wireFormat) {
            message.tier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.tier);
        }
        return message;
    }
};
var defaultEvaluationInfo = {
    metrics: [],
    parameters: [],
    steps: [],
    isCompetitionEnabled: false,
    isCompetitionClosed: false
};
export var EvaluationInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEvaluationInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.metrics) {
            message.metrics = wireFormat.metrics.map(function(i) {
                return EvaluationMetricMetadataWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.metric) {
            message.metric = EvaluationMetricWireFormat3.fromJson(wireFormat.metric);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.parameters) {
            message.parameters = wireFormat.parameters.map(function(i) {
                return EvaluationMetricParameterWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.solutionColumnMapping) {
            message.solutionColumnMapping = ColumnMappingWireFormat3.fromJson(wireFormat.solutionColumnMapping);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submissionColumnMapping) {
            message.submissionColumnMapping = ColumnMappingWireFormat3.fromJson(wireFormat.submissionColumnMapping);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.solutionInfo) {
            message.solutionInfo = SolutionInfoWireFormat3.fromJson(wireFormat.solutionInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.steps) {
            message.steps = wireFormat.steps.map(function(i) {
                return EvaluationStepWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultEvaluationMetric = {
    id: 0,
    name: "",
    abbreviation: "",
    isPublic: false,
    solutionColumns: [],
    submissionColumns: [],
    parameters: []
};
export var EvaluationMetricWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEvaluationMetric, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.solutionColumns) {
            message.solutionColumns = wireFormat.solutionColumns.map(function(i) {
                return ColumnDefinitionWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submissionColumns) {
            message.submissionColumns = wireFormat.submissionColumns.map(function(i) {
                return ColumnDefinitionWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.parameters) {
            message.parameters = wireFormat.parameters.map(function(i) {
                return EvaluationMetricParameterWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultEvaluationMetricMetadata = {
    id: 0,
    name: "",
    isPublic: false,
    abbr: ""
};
export var EvaluationMetricMetadataWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEvaluationMetricMetadata, wireFormat);
        return message;
    }
};
var defaultEvaluationMetricParameter = {
    name: "",
    type: "",
    value: ""
};
export var EvaluationMetricParameterWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEvaluationMetricParameter, wireFormat);
        return message;
    }
};
export var GetBackgroundOperationRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetCompetitionHasSubmissionColumnMappingRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetCompetitionHasSubmissionColumnMappingResponse = {
    hasSubmissionColumnMapping: false
};
export var GetCompetitionHasSubmissionColumnMappingResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetCompetitionHasSubmissionColumnMappingResponse, wireFormat);
        return message;
    }
};
export var GetEvaluationMetricRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetHostChecklistRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetHostClaimsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetHostEvaluationInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetMostRecentSubmissionStatusRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetMostRecentSubmissionStatusResponse = {};
export var GetMostRecentSubmissionStatusResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetMostRecentSubmissionStatusResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submission) {
            message.submission = LegacySubmissionExtendedWireFormat3.fromJson(wireFormat.submission);
        }
        return message;
    }
};
export var GetSolutionColumnMappingRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetSolutionColumnMappingResponse = {};
export var GetSolutionColumnMappingResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetSolutionColumnMappingResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.solutionColumnMapping) {
            message.solutionColumnMapping = ColumnMappingWireFormat3.fromJson(wireFormat.solutionColumnMapping);
        }
        return message;
    }
};
export var GetSolutionInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetSubmissionColumnMappingRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetSubmissionColumnMappingResponse = {};
export var GetSubmissionColumnMappingResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetSubmissionColumnMappingResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submissionColumnMapping) {
            message.submissionColumnMapping = ColumnMappingWireFormat3.fromJson(wireFormat.submissionColumnMapping);
        }
        return message;
    }
};
var defaultHostChecklist = {
    isCompetitionPending: false,
    children: []
};
export var HostChecklistWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHostChecklist, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.children) {
            message.children = wireFormat.children.map(function(i) {
                return HostChecklistItemWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultHostChecklistItem = {
    ok: false,
    message: "",
    tips: [],
    useHistory: false
};
export var HostChecklistItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHostChecklistItem, wireFormat);
        return message;
    }
};
var defaultHostEvaluationInfo = {
    topMetricIds: []
};
export var HostEvaluationInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHostEvaluationInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.evaluationInfo) {
            message.evaluationInfo = EvaluationInfoWireFormat3.fromJson(wireFormat.evaluationInfo);
        }
        return message;
    }
};
var defaultHostSegmentItem = {};
export var HostSegmentItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHostSegmentItem, wireFormat);
        if (wireFormat) {
            message.value = KaggleSdkCompetitionsHostSegmentWireFormat3.fromJson(wireFormat.value);
        }
        return message;
    }
};
var defaultHostUserAvatar = {
    isAlreadyHost: false
};
export var HostUserAvatarWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHostUserAvatar, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.user) {
            message.user = KaggleSdkUsersUserAvatarWireFormat3.fromJson(wireFormat.user);
        }
        return message;
    }
};
export var InvalidateSubmissionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var LaunchCompetitionRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.futureTime) {
            wireFormat.futureTime = message.futureTime.toISOString();
        }
        return wireFormat;
    }
};
var defaultLaunchCompetitionResponse = {};
export var LaunchCompetitionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLaunchCompetitionResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.launchTime) {
            message.launchTime = new Date(wireFormat.launchTime);
        }
        return message;
    }
};
export var LegacyColumnMappingWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var LegacyGetCompetitionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var LegacyGetLeaderboardRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.leaderboardType) {
            wireFormat.leaderboardType = CompetitionLeaderboardTypeWireFormat3.toJson(message.leaderboardType);
        }
        return wireFormat;
    }
};
var defaultLegacyGetLeaderboardResponse = {
    submissions: [],
    beforeUser: [],
    nearUser: [],
    afterUser: [],
    totalRankings: 0
};
export var LegacyGetLeaderboardResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLegacyGetLeaderboardResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submissions) {
            message.submissions = wireFormat.submissions.map(function(i) {
                return CompetitionLeaderboardSubmissionDtoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.beforeUser) {
            message.beforeUser = wireFormat.beforeUser.map(function(i) {
                return CompetitionLeaderboardSubmissionDtoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.nearUser) {
            message.nearUser = wireFormat.nearUser.map(function(i) {
                return CompetitionLeaderboardSubmissionDtoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.afterUser) {
            message.afterUser = wireFormat.afterUser.map(function(i) {
                return CompetitionLeaderboardSubmissionDtoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var LegacyListCompetitionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.tab) {
            wireFormat.tab = KaggleSdkCompetitionsCompetitionListTabWireFormat3.toJson(message.tab);
        }
        if (message === null || message === void 0 ? void 0 : message.category) {
            wireFormat.category = KaggleSdkCompetitionsHostSegmentWireFormat3.toJson(message.category);
        }
        if (message === null || message === void 0 ? void 0 : message.sortBy) {
            wireFormat.sortBy = KaggleSdkCompetitionsCompetitionSortByWireFormat3.toJson(message.sortBy);
        }
        return wireFormat;
    }
};
var defaultLegacyListCompetitionsResponse = {
    sortByOptions: [],
    tabOptions: [],
    categoryOptions: [],
    fullCompetitionGroups: []
};
export var LegacyListCompetitionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLegacyListCompetitionsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.sortByOptions) {
            message.sortByOptions = wireFormat.sortByOptions.map(function(i) {
                return ValueLabelWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tabOptions) {
            message.tabOptions = wireFormat.tabOptions.map(function(i) {
                return ValueLabelWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categoryOptions) {
            message.categoryOptions = wireFormat.categoryOptions.map(function(i) {
                return ValueLabelWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.fullCompetitionGroups) {
            message.fullCompetitionGroups = wireFormat.fullCompetitionGroups.map(function(i) {
                return CompetitionGroupDtoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.pagedCompetitionGroup) {
            message.pagedCompetitionGroup = CompetitionGroupDtoWireFormat3.fromJson(wireFormat.pagedCompetitionGroup);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.values) {
            message.values = ViewCompetitionListValuesDtoWireFormat3.fromJson(wireFormat.values);
        }
        return message;
    }
};
export var LegacyListTeamsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.sortBy) {
            wireFormat.sortBy = CompetitionTeamSortByWireFormat3.toJson(message.sortBy);
        }
        return wireFormat;
    }
};
var defaultLegacyListTeamsResponse = {
    teamsList: [],
    hasMoreData: false,
    sortByOptions: [],
    totalTeams: 0,
    totalSubmissions: 0
};
export var LegacyListTeamsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLegacyListTeamsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teamsList) {
            message.teamsList = wireFormat.teamsList.map(function(i) {
                return CompetitionTeamInfoDtoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.sortByOptions) {
            message.sortByOptions = wireFormat.sortByOptions.map(function(i) {
                return ValueLabelWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultLegacySandboxSubmission = {
    id: 0,
    name: "",
    isBenchmark: false,
    downloadUrl: ""
};
export var LegacySandboxSubmissionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLegacySandboxSubmission, wireFormat);
        if (wireFormat) {
            message.submissionStatus = KaggleSdkCompetitionsSubmissionStatusWireFormat3.fromJson(wireFormat.submissionStatus);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateSubmitted) {
            message.dateSubmitted = new Date(wireFormat.dateSubmitted);
        }
        return message;
    }
};
var defaultLegacySubmissionExtended = {
    id: 0,
    name: "",
    totalSubmissionsInLine: 0,
    competitionName: "",
    competitionSlug: "",
    userDisplayName: "",
    userName: "",
    isBenchmark: false,
    downloadUrl: ""
};
export var LegacySubmissionExtendedWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLegacySubmissionExtended, wireFormat);
        if (wireFormat) {
            message.submissionStatus = KaggleSdkCompetitionsSubmissionStatusWireFormat3.fromJson(wireFormat.submissionStatus);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateSubmitted) {
            message.dateSubmitted = new Date(wireFormat.dateSubmitted);
        }
        if (wireFormat) {
            message.priority = LegacyWorkerPriorityWireFormat3.fromJson(wireFormat.priority);
        }
        return message;
    }
};
var defaultLegacyTeamSubmission = {
    id: 0,
    isSelected: false,
    isChecked: false,
    isAfterDeadline: false
};
export var LegacyTeamSubmissionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLegacyTeamSubmission, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.contentLength) {
            message.contentLength = parseInt(wireFormat.contentLength);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
            message.date = new Date(wireFormat.date);
        }
        if (wireFormat) {
            message.status = KaggleSdkCompetitionsSubmissionStatusWireFormat3.fromJson(wireFormat.status);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.syncRerunState) {
            message.syncRerunState = KaggleSdkCompetitionsCompetitionKernelRerunStateWireFormat3.fromJson(wireFormat.syncRerunState);
        }
        return message;
    }
};
export var ListHostUsersRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListHostUsersResponse = {
    hosts: []
};
export var ListHostUsersResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListHostUsersResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.hosts) {
            message.hosts = wireFormat.hosts.map(function(i) {
                return KaggleSdkUsersUserAvatarWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListMySubmissionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.sortBy) {
            wireFormat.sortBy = KaggleSdkCompetitionsSubmissionSortByWireFormat3.toJson(message.sortBy);
        }
        if (message === null || message === void 0 ? void 0 : message.group) {
            wireFormat.group = KaggleSdkCompetitionsSubmissionGroupWireFormat3.toJson(message.group);
        }
        return wireFormat;
    }
};
var defaultListMySubmissionsResponse = {
    submissions: []
};
export var ListMySubmissionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListMySubmissionsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submissions) {
            message.submissions = wireFormat.submissions.map(function(i) {
                return LegacyTeamSubmissionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListSandboxSubmissionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListSandboxSubmissionsResponse = {
    sandboxSubmissions: []
};
export var ListSandboxSubmissionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListSandboxSubmissionsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.sandboxSubmissions) {
            message.sandboxSubmissions = wireFormat.sandboxSubmissions.map(function(i) {
                return LegacySandboxSubmissionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListTeamSubmissionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListTeamSubmissionsResponse = {
    teamSubmissions: []
};
export var ListTeamSubmissionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListTeamSubmissionsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teamSubmissions) {
            message.teamSubmissions = wireFormat.teamSubmissions.map(function(i) {
                return LegacyTeamSubmissionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ObliterateEvaluationFromStepRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.evaluationStep) {
            wireFormat.evaluationStep = EvaluationStepWireFormat3.toJson(message.evaluationStep);
        }
        return wireFormat;
    }
};
export var PagingParametersWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var RemoveHostUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var RescoreSubmissionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.rescoreType) {
            wireFormat.rescoreType = BulkRescoreSubmissionsTypeWireFormat3.toJson(message.rescoreType);
        }
        if (message === null || message === void 0 ? void 0 : message.specificSubmissionsToRescore) {
            wireFormat.specificSubmissionsToRescore = RescoreSubmissionsRequest.SpecificSubmissionsWireFormat3.toJson(message.specificSubmissionsToRescore);
        }
        if (message === null || message === void 0 ? void 0 : message.pagingParameters) {
            wireFormat.pagingParameters = PagingParametersWireFormat3.toJson(message.pagingParameters);
        }
        return wireFormat;
    }
};
export var SearchHostUsersRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSearchHostUsersResponse = {
    users: []
};
export var SearchHostUsersResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSearchHostUsersResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.users) {
            message.users = wireFormat.users.map(function(i) {
                return HostUserAvatarWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var SetBenchmarkSubmissionNameRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var SetEvaluationMetricParametersRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var SetEvaluationMetricRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSolutionInfo = {
    hasRaw: false,
    hasDerived: false,
    samplingPercentage: 0
};
export var SolutionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSolutionInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.uploadDate) {
            message.uploadDate = new Date(wireFormat.uploadDate);
        }
        return message;
    }
};
var defaultSubmissionsRange = {
    count: 0,
    minId: 0,
    maxId: 0
};
export var SubmissionsRangeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSubmissionsRange, wireFormat);
        return message;
    }
};
var defaultSubmissionStatusDto = {
    id: 0,
    totalSubmissionsInLine: 0,
    isBenchmark: false
};
export var SubmissionStatusDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSubmissionStatusDto, wireFormat);
        if (wireFormat) {
            message.submissionStatus = KaggleSdkCompetitionsSubmissionStatusWireFormat3.fromJson(wireFormat.submissionStatus);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateSubmitted) {
            message.dateSubmitted = new Date(wireFormat.dateSubmitted);
        }
        if (wireFormat) {
            message.priority = LegacyWorkerPriorityWireFormat3.fromJson(wireFormat.priority);
        }
        return message;
    }
};
export var ToggleBenchmarkSubmissionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateCompetitionSettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.hostSegment) {
            wireFormat.hostSegment = KaggleSdkCompetitionsHostSegmentWireFormat3.toJson(message.hostSegment);
        }
        if (message === null || message === void 0 ? void 0 : message.deadline) {
            wireFormat.deadline = message.deadline.toISOString();
        }
        if (message === null || message === void 0 ? void 0 : message.privateLeaderboardReleaseDate) {
            wireFormat.privateLeaderboardReleaseDate = message.privateLeaderboardReleaseDate.toISOString();
        }
        return wireFormat;
    }
};
export var UpdateImagesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.header) {
            wireFormat.header = KaggleSdkCommonCroppedImageUploadWireFormat3.toJson(message.header);
        }
        if (message === null || message === void 0 ? void 0 : message.thumbnail) {
            wireFormat.thumbnail = KaggleSdkCommonCroppedImageUploadWireFormat3.toJson(message.thumbnail);
        }
        return wireFormat;
    }
};
var defaultUpdateImagesResponse = {};
export var UpdateImagesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateImagesResponse, wireFormat);
        return message;
    }
};
export var UpdateOverviewRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.overviewPages) {
            wireFormat.overviewPages = message.overviewPages.map(function(i) {
                return CompetitionPageWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultUpdateOverviewResponse = {
    pages: []
};
export var UpdateOverviewResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateOverviewResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.pages) {
            message.pages = wireFormat.pages.map(function(i) {
                return CompetitionPageWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var UpdatePageRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.page) {
            wireFormat.page = CompetitionPageWireFormat3.toJson(message.page);
        }
        return wireFormat;
    }
};
export var UpdateSolutionColumnMappingRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.columnMapping) {
            wireFormat.columnMapping = LegacyColumnMappingWireFormat3.toJson(message.columnMapping);
        }
        return wireFormat;
    }
};
export var UpdateSubmissionColumnMappingRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.columnMapping) {
            wireFormat.columnMapping = LegacyColumnMappingWireFormat3.toJson(message.columnMapping);
        }
        return wireFormat;
    }
};
export var UpdateTeamVisibilityRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultValueLabel = {};
export var ValueLabelWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultValueLabel, wireFormat);
        return message;
    }
};
var defaultViewCompetitionListValuesDto = {
    page: 0
};
export var ViewCompetitionListValuesDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultViewCompetitionListValuesDto, wireFormat);
        if (wireFormat) {
            message.tab = KaggleSdkCompetitionsCompetitionListTabWireFormat3.fromJson(wireFormat.tab);
        }
        if (wireFormat) {
            message.sortBy = KaggleSdkCompetitionsCompetitionSortByWireFormat3.fromJson(wireFormat.sortBy);
        }
        if (wireFormat) {
            message.category = KaggleSdkCompetitionsHostSegmentWireFormat3.fromJson(wireFormat.category);
        }
        return message;
    }
};
export var WaitBackgroundOperationRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var BulkRescoreSubmissionsType;
(function(BulkRescoreSubmissionsType) {
    BulkRescoreSubmissionsType["UNSPECIFIED"] = "unspecified";
    BulkRescoreSubmissionsType["ALL"] = "all";
    BulkRescoreSubmissionsType["COMPLETED"] = "completed";
    BulkRescoreSubmissionsType["COMPLETED_WITHOUT_DETAIL"] = "completedWithoutDetail";
    BulkRescoreSubmissionsType["AFTER_DEADLINE"] = "afterDeadline";
    BulkRescoreSubmissionsType["PENDING"] = "pending";
    BulkRescoreSubmissionsType["ERRORED"] = "errored";
    BulkRescoreSubmissionsType["SPECIFIC"] = "specific";
    BulkRescoreSubmissionsType["SITEWIDE_SPECIFIC"] = "sitewideSpecific";
    BulkRescoreSubmissionsType["SITEWIDE_PENDING"] = "sitewidePending";
})(BulkRescoreSubmissionsType || (BulkRescoreSubmissionsType = {}));
export var BulkRescoreSubmissionsTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case BulkRescoreSubmissionsType.UNSPECIFIED:
            case 0:
            default:
                return "BULK_RESCORE_SUBMISSIONS_TYPE_UNSPECIFIED";
            case BulkRescoreSubmissionsType.ALL:
            case 1:
                return "ALL";
            case BulkRescoreSubmissionsType.COMPLETED:
            case 2:
                return "COMPLETED";
            case BulkRescoreSubmissionsType.COMPLETED_WITHOUT_DETAIL:
            case 3:
                return "COMPLETED_WITHOUT_DETAIL";
            case BulkRescoreSubmissionsType.AFTER_DEADLINE:
            case 4:
                return "AFTER_DEADLINE";
            case BulkRescoreSubmissionsType.PENDING:
            case 5:
                return "PENDING";
            case BulkRescoreSubmissionsType.ERRORED:
            case 6:
                return "ERRORED";
            case BulkRescoreSubmissionsType.SPECIFIC:
            case 7:
                return "SPECIFIC";
            case BulkRescoreSubmissionsType.SITEWIDE_SPECIFIC:
            case 8:
                return "SITEWIDE_SPECIFIC";
            case BulkRescoreSubmissionsType.SITEWIDE_PENDING:
            case 9:
                return "SITEWIDE_PENDING";
        }
    }
};
export var CompetitionLeaderboardType;
(function(CompetitionLeaderboardType) {
    CompetitionLeaderboardType["PUBLIC"] = "public";
    CompetitionLeaderboardType["PRIVATE"] = "private";
    CompetitionLeaderboardType["ACTIVE"] = "active";
})(CompetitionLeaderboardType || (CompetitionLeaderboardType = {}));
export var CompetitionLeaderboardTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CompetitionLeaderboardType.PUBLIC:
            case 0:
            default:
                return "PUBLIC";
            case CompetitionLeaderboardType.PRIVATE:
            case 1:
                return "PRIVATE";
            case CompetitionLeaderboardType.ACTIVE:
            case 2:
                return "ACTIVE";
        }
    }
};
export var CompetitionPageError;
(function(CompetitionPageError) {
    CompetitionPageError["UNSPECIFIED"] = "unspecified";
    CompetitionPageError[// Page name has special meaning (e.g. "rules" or "data") and is reserved.
    "RESERVED_NAME"] = "reservedName";
    CompetitionPageError[// Page name is already in use.
    "DUPLICATE_NAME"] = "duplicateName";
    CompetitionPageError["CONCURRENT_EDIT"] = "concurrentEdit";
})(CompetitionPageError || (CompetitionPageError = {}));
export var CompetitionTeamSortBy;
(function(CompetitionTeamSortBy) {
    CompetitionTeamSortBy["RANK"] = "rank";
    CompetitionTeamSortBy["PUBLIC_SCORE_ASC"] = "publicScoreAsc";
    CompetitionTeamSortBy["PUBLIC_SCORE_DESC"] = "publicScoreDesc";
    CompetitionTeamSortBy["PRIVATE_SCORE_ASC"] = "privateScoreAsc";
    CompetitionTeamSortBy["PRIVATE_SCORE_DESC"] = "privateScoreDesc";
})(CompetitionTeamSortBy || (CompetitionTeamSortBy = {}));
export var CompetitionTeamSortByWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CompetitionTeamSortBy.RANK:
            case 0:
            default:
                return "RANK";
            case CompetitionTeamSortBy.PUBLIC_SCORE_ASC:
            case 1:
                return "PUBLIC_SCORE_ASC";
            case CompetitionTeamSortBy.PUBLIC_SCORE_DESC:
            case 2:
                return "PUBLIC_SCORE_DESC";
            case CompetitionTeamSortBy.PRIVATE_SCORE_ASC:
            case 3:
                return "PRIVATE_SCORE_ASC";
            case CompetitionTeamSortBy.PRIVATE_SCORE_DESC:
            case 4:
                return "PRIVATE_SCORE_DESC";
        }
    }
};
export var EvaluationStep;
(function(EvaluationStep) {
    EvaluationStep["UNSPECIFIED"] = "unspecified";
    EvaluationStep["METRIC"] = "metric";
    EvaluationStep["PARAMETER"] = "parameter";
    EvaluationStep["SOLUTION"] = "solution";
    EvaluationStep["SOLUTION_MAPPING"] = "solutionMapping";
    EvaluationStep["SUBMISSION"] = "submission";
    EvaluationStep["SUBMISSION_MAPPING"] = "submissionMapping";
})(EvaluationStep || (EvaluationStep = {}));
export var EvaluationStepWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "EVALUATION_STEP_UNSPECIFIED":
            default:
                return EvaluationStep.UNSPECIFIED;
            case "METRIC":
                return EvaluationStep.METRIC;
            case "PARAMETER":
                return EvaluationStep.PARAMETER;
            case "SOLUTION":
                return EvaluationStep.SOLUTION;
            case "SOLUTION_MAPPING":
                return EvaluationStep.SOLUTION_MAPPING;
            case "SUBMISSION":
                return EvaluationStep.SUBMISSION;
            case "SUBMISSION_MAPPING":
                return EvaluationStep.SUBMISSION_MAPPING;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case EvaluationStep.UNSPECIFIED:
            case 0:
            default:
                return "EVALUATION_STEP_UNSPECIFIED";
            case EvaluationStep.METRIC:
            case 1:
                return "METRIC";
            case EvaluationStep.PARAMETER:
            case 2:
                return "PARAMETER";
            case EvaluationStep.SOLUTION:
            case 3:
                return "SOLUTION";
            case EvaluationStep.SOLUTION_MAPPING:
            case 4:
                return "SOLUTION_MAPPING";
            case EvaluationStep.SUBMISSION:
            case 5:
                return "SUBMISSION";
            case EvaluationStep.SUBMISSION_MAPPING:
            case 6:
                return "SUBMISSION_MAPPING";
        }
    }
};
export var LegacyWorkerPriority;
(function(LegacyWorkerPriority) {
    LegacyWorkerPriority["NORMAL"] = "normal";
    LegacyWorkerPriority["BACKGROUND"] = "background";
})(LegacyWorkerPriority || (LegacyWorkerPriority = {}));
export var LegacyWorkerPriorityWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "NORMAL":
            default:
                return LegacyWorkerPriority.NORMAL;
            case "BACKGROUND":
                return LegacyWorkerPriority.BACKGROUND;
        }
    }
};
// Loosely based on https://github.com/googleapis/googleapis/blob/master/google/longrunning/operations.proto
// Prefixed with "Background" to avoid conflict with that one.
// Has historically only been used by Competitions but could eventually be made into an official (non-Legacy) service.
export var competitionsLegacyClient = {
    legacyCompetitionBackgroundService: {
        getBackgroundOperation: createClient(GetBackgroundOperationRequestWireFormat3, BackgroundOperationWireFormat3, "competitions.legacy.LegacyCompetitionBackgroundService/GetBackgroundOperation"),
        waitBackgroundOperation: createClient(WaitBackgroundOperationRequestWireFormat3, BackgroundOperationWireFormat3, "competitions.legacy.LegacyCompetitionBackgroundService/WaitBackgroundOperation")
    },
    legacyCompetitionHostService: {
        // Adds a user to the competition's admin group.
        addHostUser: createClient(AddHostUserRequestWireFormat3, AddHostUserResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/AddHostUser"),
        // Note that this name is somewhat overloaded in that it checks if there is a
        // mapping OR if it's a simulations competition. It should likely be
        // refactored to clean this up.
        getCompetitionHasSubmissionColumnMapping: createClient(GetCompetitionHasSubmissionColumnMappingRequestWireFormat3, GetCompetitionHasSubmissionColumnMappingResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/GetCompetitionHasSubmissionColumnMapping"),
        getEvaluationMetric: createClient(GetEvaluationMetricRequestWireFormat3, EvaluationMetricWireFormat3, "competitions.legacy.LegacyCompetitionHostService/GetEvaluationMetric"),
        // Gets details to render the host checklist page.
        getHostChecklist: createClient(GetHostChecklistRequestWireFormat3, HostChecklistWireFormat3, "competitions.legacy.LegacyCompetitionHostService/GetHostChecklist"),
        // Gets claims/permissions that inform the host what they can do (and adjust
        // the UI appropriately).
        getHostClaims: createClient(GetHostClaimsRequestWireFormat3, CompetitionHostClaimsWireFormat3, "competitions.legacy.LegacyCompetitionHostService/GetHostClaims"),
        getHostEvaluationInfo: createClient(GetHostEvaluationInfoRequestWireFormat3, HostEvaluationInfoWireFormat3, "competitions.legacy.LegacyCompetitionHostService/GetHostEvaluationInfo"),
        // (-- aip.dev/not-precedent: Not returning a ColumnMapping message directly
        // yet to preserve existing client behavior of
        // expecting a null value if not set.)
        getSolutionColumnMapping: createClient(GetSolutionColumnMappingRequestWireFormat3, GetSolutionColumnMappingResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/GetSolutionColumnMapping"),
        getSolutionInfo: createClient(GetSolutionInfoRequestWireFormat3, SolutionInfoWireFormat3, "competitions.legacy.LegacyCompetitionHostService/GetSolutionInfo"),
        // (-- aip.dev/not-precedent: Not returning a ColumnMapping message directly
        // yet to preserve existing client behavior of
        // expecting a null value if not set.)
        getSubmissionColumnMapping: createClient(GetSubmissionColumnMappingRequestWireFormat3, GetSubmissionColumnMappingResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/GetSubmissionColumnMapping"),
        invalidateSubmissions: createClient(InvalidateSubmissionsRequestWireFormat3, BackgroundOperationWireFormat3, "competitions.legacy.LegacyCompetitionHostService/InvalidateSubmissions"),
        // Launch the competition (or set it to be launched in the future) so that it
        // becomes visible to participants.
        launchCompetition: createClient(LaunchCompetitionRequestWireFormat3, LaunchCompetitionResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/LaunchCompetition"),
        // Lists all of the users that are members of the competition's admin group.
        listHostUsers: createClient(ListHostUsersRequestWireFormat3, ListHostUsersResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/ListHostUsers"),
        obliterateEvaluationFromStep: createClient(ObliterateEvaluationFromStepRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.legacy.LegacyCompetitionHostService/ObliterateEvaluationFromStep"),
        // Removes a user from the competition's admin group.
        removeHostUser: createClient(RemoveHostUserRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.legacy.LegacyCompetitionHostService/RemoveHostUser"),
        // Rescores the specified submissions.
        rescoreSubmissions: createClient(RescoreSubmissionsRequestWireFormat3, BackgroundOperationWireFormat3, "competitions.legacy.LegacyCompetitionHostService/RescoreSubmissions"),
        // Searches for users that could be added as a host to a competition's admin
        // group.
        searchHostUsers: createClient(SearchHostUsersRequestWireFormat3, SearchHostUsersResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/SearchHostUsers"),
        setBenchmarkSubmissionName: createClient(SetBenchmarkSubmissionNameRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.legacy.LegacyCompetitionHostService/SetBenchmarkSubmissionName"),
        setEvaluationMetric: createClient(SetEvaluationMetricRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.legacy.LegacyCompetitionHostService/SetEvaluationMetric"),
        setEvaluationMetricParameters: createClient(SetEvaluationMetricParametersRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.legacy.LegacyCompetitionHostService/SetEvaluationMetricParameters"),
        toggleBenchmarkSubmission: createClient(ToggleBenchmarkSubmissionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.legacy.LegacyCompetitionHostService/ToggleBenchmarkSubmission"),
        // Saves the data on the "Settings" page.
        // (-- aip.dev/not-precedent: Not returning anything on Update to match legacy
        // API.)
        updateCompetitionSettings: createClient(UpdateCompetitionSettingsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.legacy.LegacyCompetitionHostService/UpdateCompetitionSettings"),
        // Updates the header and/or thumbnail images associated with the competition.
        updateImages: createClient(UpdateImagesRequestWireFormat3, UpdateImagesResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/UpdateImages"),
        // Updates the competition overview pages.
        updateOverview: createClient(UpdateOverviewRequestWireFormat3, UpdateOverviewResponseWireFormat3, "competitions.legacy.LegacyCompetitionHostService/UpdateOverview"),
        // Updates a single page.
        updatePage: createClient(UpdatePageRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.legacy.LegacyCompetitionHostService/UpdatePage"),
        updateSolutionColumnMapping: createClient(UpdateSolutionColumnMappingRequestWireFormat3, BackgroundOperationWireFormat3, "competitions.legacy.LegacyCompetitionHostService/UpdateSolutionColumnMapping"),
        updateSubmissionColumnMapping: createClient(UpdateSubmissionColumnMappingRequestWireFormat3, BackgroundOperationWireFormat3, "competitions.legacy.LegacyCompetitionHostService/UpdateSubmissionColumnMapping"),
        updateTeamVisibility: createClient(UpdateTeamVisibilityRequestWireFormat3, BackgroundOperationWireFormat3, "competitions.legacy.LegacyCompetitionHostService/UpdateTeamVisibility")
    },
    legacyCompetitionService: {
        getCompetition: createClient(LegacyGetCompetitionRequestWireFormat3, CompetitionDtoWireFormat3, "competitions.legacy.LegacyCompetitionService/GetCompetition"),
        getLeaderboard: createClient(LegacyGetLeaderboardRequestWireFormat3, LegacyGetLeaderboardResponseWireFormat3, "competitions.legacy.LegacyCompetitionService/GetLeaderboard"),
        listCompetitions: createClient(LegacyListCompetitionsRequestWireFormat3, LegacyListCompetitionsResponseWireFormat3, "competitions.legacy.LegacyCompetitionService/ListCompetitions"),
        listTeams: createClient(LegacyListTeamsRequestWireFormat3, LegacyListTeamsResponseWireFormat3, "competitions.legacy.LegacyCompetitionService/ListTeams")
    },
    legacySubmissionService: {
        // Gets the status of the current user's most recent submission.
        getMostRecentSubmissionStatus: createClient(GetMostRecentSubmissionStatusRequestWireFormat3, GetMostRecentSubmissionStatusResponseWireFormat3, "competitions.legacy.LegacySubmissionService/GetMostRecentSubmissionStatus"),
        listMySubmissions: createClient(ListMySubmissionsRequestWireFormat3, ListMySubmissionsResponseWireFormat3, "competitions.legacy.LegacySubmissionService/ListMySubmissions"),
        listSandboxSubmissions: createClient(ListSandboxSubmissionsRequestWireFormat3, ListSandboxSubmissionsResponseWireFormat3, "competitions.legacy.LegacySubmissionService/ListSandboxSubmissions"),
        listTeamSubmissions: createClient(ListTeamSubmissionsRequestWireFormat3, ListTeamSubmissionsResponseWireFormat3, "competitions.legacy.LegacySubmissionService/ListTeamSubmissions")
    }
};
